import {createAsyncThunk} from '@reduxjs/toolkit';
import type {TemplateSubmissionData} from '@Components/template-submission-flow/template-submission-flow.types';

export const submitTemplate = createAsyncThunk('submitTemplate', async (data: TemplateSubmissionData) => {
  return window.PMW.writeLocal('sell/savesubmission', data);
});
